module.exports = __webpack_public_path__ + "img/block-768.9a45c6c1.jpg";